import React from "react";
import { Button } from "@cloudscape-design/components-themed/components";
export const renderTableActions = (action, data) => {
    return (React.createElement(Button, { key: "inspect-button", variant: "inline-icon", iconName: "search", ariaLabel: "inspect-button", onClick: () => {
            action(data);
        } }));
};
